/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppAbsenceRouteImport } from './routes/_app.absence'

const AppIndexLazyRouteImport = createFileRoute('/_app/')()
const AuthPasswordResetLazyRouteImport = createFileRoute(
  '/auth/password-reset',
)()
const AuthLogoutLazyRouteImport = createFileRoute('/auth/logout')()
const AuthLoginLazyRouteImport = createFileRoute('/auth/login')()
const Auth2faEnableLazyRouteImport = createFileRoute('/auth/2fa-enable')()
const AppUsersLazyRouteImport = createFileRoute('/_app/users')()
const AppTeamLazyRouteImport = createFileRoute('/_app/team')()
const AppSettingsLazyRouteImport = createFileRoute('/_app/settings')()
const AppScheduleLazyRouteImport = createFileRoute('/_app/schedule')()
const AppJobsLazyRouteImport = createFileRoute('/_app/jobs')()
const AppDashboardLazyRouteImport = createFileRoute('/_app/dashboard')()
const AppClientsLazyRouteImport = createFileRoute('/_app/clients')()
const AppAdminLazyRouteImport = createFileRoute('/_app/admin')()

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexLazyRoute = AppIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.index.lazy').then((d) => d.Route))
const AuthPasswordResetLazyRoute = AuthPasswordResetLazyRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth.password-reset.lazy').then((d) => d.Route),
)
const AuthLogoutLazyRoute = AuthLogoutLazyRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.logout.lazy').then((d) => d.Route))
const AuthLoginLazyRoute = AuthLoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.login.lazy').then((d) => d.Route))
const Auth2faEnableLazyRoute = Auth2faEnableLazyRouteImport.update({
  id: '/2fa-enable',
  path: '/2fa-enable',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth.2fa-enable.lazy').then((d) => d.Route),
)
const AppUsersLazyRoute = AppUsersLazyRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.users.lazy').then((d) => d.Route))
const AppTeamLazyRoute = AppTeamLazyRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.team.lazy').then((d) => d.Route))
const AppSettingsLazyRoute = AppSettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.settings.lazy').then((d) => d.Route))
const AppScheduleLazyRoute = AppScheduleLazyRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.schedule.lazy').then((d) => d.Route))
const AppJobsLazyRoute = AppJobsLazyRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.jobs.lazy').then((d) => d.Route))
const AppDashboardLazyRoute = AppDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app.dashboard.lazy').then((d) => d.Route),
)
const AppClientsLazyRoute = AppClientsLazyRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.clients.lazy').then((d) => d.Route))
const AppAdminLazyRoute = AppAdminLazyRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app.admin.lazy').then((d) => d.Route))
const AppAbsenceRoute = AppAbsenceRouteImport.update({
  id: '/absence',
  path: '/absence',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteWithChildren
  '/absence': typeof AppAbsenceRoute
  '/admin': typeof AppAdminLazyRoute
  '/clients': typeof AppClientsLazyRoute
  '/dashboard': typeof AppDashboardLazyRoute
  '/jobs': typeof AppJobsLazyRoute
  '/schedule': typeof AppScheduleLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/team': typeof AppTeamLazyRoute
  '/users': typeof AppUsersLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/': typeof AppIndexLazyRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/absence': typeof AppAbsenceRoute
  '/admin': typeof AppAdminLazyRoute
  '/clients': typeof AppClientsLazyRoute
  '/dashboard': typeof AppDashboardLazyRoute
  '/jobs': typeof AppJobsLazyRoute
  '/schedule': typeof AppScheduleLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/team': typeof AppTeamLazyRoute
  '/users': typeof AppUsersLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/': typeof AppIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_app/absence': typeof AppAbsenceRoute
  '/_app/admin': typeof AppAdminLazyRoute
  '/_app/clients': typeof AppClientsLazyRoute
  '/_app/dashboard': typeof AppDashboardLazyRoute
  '/_app/jobs': typeof AppJobsLazyRoute
  '/_app/schedule': typeof AppScheduleLazyRoute
  '/_app/settings': typeof AppSettingsLazyRoute
  '/_app/team': typeof AppTeamLazyRoute
  '/_app/users': typeof AppUsersLazyRoute
  '/auth/2fa-enable': typeof Auth2faEnableLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/password-reset': typeof AuthPasswordResetLazyRoute
  '/_app/': typeof AppIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/absence'
    | '/admin'
    | '/clients'
    | '/dashboard'
    | '/jobs'
    | '/schedule'
    | '/settings'
    | '/team'
    | '/users'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/absence'
    | '/admin'
    | '/clients'
    | '/dashboard'
    | '/jobs'
    | '/schedule'
    | '/settings'
    | '/team'
    | '/users'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/absence'
    | '/_app/admin'
    | '/_app/clients'
    | '/_app/dashboard'
    | '/_app/jobs'
    | '/_app/schedule'
    | '/_app/settings'
    | '/_app/team'
    | '/_app/users'
    | '/auth/2fa-enable'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/password-reset'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/2fa-enable': {
      id: '/auth/2fa-enable'
      path: '/2fa-enable'
      fullPath: '/auth/2fa-enable'
      preLoaderRoute: typeof Auth2faEnableLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs': {
      id: '/_app/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AppJobsLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/absence': {
      id: '/_app/absence'
      path: '/absence'
      fullPath: '/absence'
      preLoaderRoute: typeof AppAbsenceRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAbsenceRoute: typeof AppAbsenceRoute
  AppAdminLazyRoute: typeof AppAdminLazyRoute
  AppClientsLazyRoute: typeof AppClientsLazyRoute
  AppDashboardLazyRoute: typeof AppDashboardLazyRoute
  AppJobsLazyRoute: typeof AppJobsLazyRoute
  AppScheduleLazyRoute: typeof AppScheduleLazyRoute
  AppSettingsLazyRoute: typeof AppSettingsLazyRoute
  AppTeamLazyRoute: typeof AppTeamLazyRoute
  AppUsersLazyRoute: typeof AppUsersLazyRoute
  AppIndexLazyRoute: typeof AppIndexLazyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAbsenceRoute: AppAbsenceRoute,
  AppAdminLazyRoute: AppAdminLazyRoute,
  AppClientsLazyRoute: AppClientsLazyRoute,
  AppDashboardLazyRoute: AppDashboardLazyRoute,
  AppJobsLazyRoute: AppJobsLazyRoute,
  AppScheduleLazyRoute: AppScheduleLazyRoute,
  AppSettingsLazyRoute: AppSettingsLazyRoute,
  AppTeamLazyRoute: AppTeamLazyRoute,
  AppUsersLazyRoute: AppUsersLazyRoute,
  AppIndexLazyRoute: AppIndexLazyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  Auth2faEnableLazyRoute: typeof Auth2faEnableLazyRoute
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  AuthLogoutLazyRoute: typeof AuthLogoutLazyRoute
  AuthPasswordResetLazyRoute: typeof AuthPasswordResetLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faEnableLazyRoute: Auth2faEnableLazyRoute,
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  AuthLogoutLazyRoute: AuthLogoutLazyRoute,
  AuthPasswordResetLazyRoute: AuthPasswordResetLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
